import types from "./categoryConstants";

const initialState = {
    loading: false,
    categoryList: [],
    category: undefined,
    success: undefined,
    error: undefined
}

export const Category = (state = initialState, action) => {
    switch (action.type) {
        case types.GET_CATEGORIES:
            return { ...state, loading: true };
        case types.GET_CATEGORIES_SUCCESS:
            return { ...state, categoryList: action.payload.data, loading: false };
        case types.GET_CATEGORIES_FAILED:
            return { ...state, loading: false, error: action.payload.message };

        case types.GET_CATEGORY:
            return { ...state, loading: true };
        case types.GET_CATEGORY_SUCCESS:
            return { ...state, category: action.payload.data, loading: false };
        case types.GET_CATEGORY_FAILED:
            return { ...state, loading: false, error: action.payload.message };

        case types.POST_CATEGORY:
            return { ...state, loading: true, success: undefined, error: undefined };
        case types.POST_CATEGORY_SUCCESS:
            return { ...state, loading: false, success: 'CATEGORY.CREATED.SUCCESS' };
        case types.POST_CATEGORY_FAILED:
            return { ...state, loading: false, error: action.payload.message };

        case types.PATCH_CATEGORY:
            return { ...state, loading: true, success: undefined, error: undefined };
        case types.PATCH_CATEGORY_SUCCESS:
            return { ...state, loading: false, success: 'CATEGORY.UPDATED.SUCCESS' };
        case types.PATCH_CATEGORY_FAILED:
            return { ...state, loading: false, error: action.payload.message };

        case types.DELETE_CATEGORY:
            return { ...state, loading: true, success: undefined, error: undefined };
        case types.DELETE_CATEGORY_SUCCESS:
            return { ...state, loading: false, success: 'CATEGORY.DELETED.SUCCESS' };
        case types.DELETE_CATEGORY_FAILED:
            return { ...state, loading: false, error: action.payload.message };

        case types.CLEAR_STATE:
            return { ...state, success: undefined, error: undefined, category: undefined };

        default:
            return state;
    }
}

export default Category;
